import styled from 'styled-components'

const GeneralEarnWrapper = styled.div`
  padding-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  width: 100%;
  /* display:flex;
    justify-content:space-between;
    flex-direction:column; */
  height: 88vh;

  .header h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 32px;
    color: ${({ theme }) => theme.colors.CollaboBlue};
    margin: 0;
    padding: 15px 0 10px 0;
  }
  .header p {
    font-family: ${({ theme }) => theme.fontFamily.inter};
    line-height: 32px;
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontSize.s};
    margin: 0;
    padding: 0 0 10px 0;
  }
`

const EarnContainer = styled.div`
  /* 
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; */
  width: 100%;

  .input-container {
    margin-top: 5px;
    width: 100%;
  }

  .btn-container {
    display: flex;
    width: 300px;
    border: 1px solid #858c94;
    justify-content: space-between;
    border-radius: 10px;

    .btn.active-btn {
      /* background-color:${({ theme }) => theme.colors.primary}; */
      background: #ececec;
      /* color:${({ theme }) => theme.colors.white}; */
    }
  }
`

const InviteFriendContent = styled.div`
  .content {
    display: none;
  }

  .content.active-content {
    display: block;
  }

  .img-text-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h2 {
      margin: 0;
      font-size: ${({ theme }) => theme.fontSize.x2};
    }

    p {
      width: 400px;
      font-size: ${({ theme }) => theme.fontSize.x3};
      color: ${({ theme }) => theme.colors.gray};
      text-align: center;
    }
  }

  .copy {
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
  }
  .share {
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin:20px 0; */
  }
`

const ClaimRewardContent = styled.div`
  .content {
    display: none;
  }

  .content.active-content {
    display: block;
  }

  .reward-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 2rem;
    padding: 15px 0;
    width: 300px;
    height: 40px;
    background-color: ${({ theme }) => theme.colors.grey};
    border-radius: 10px;

    .border {
      height: 35px;
      width: 2px;
      background-color: ${({ theme }) => theme.colors.dark};
    }

    .pending-text,
    .pending-amount {
      margin: 0;
    }

    .pending-amount {
      color: ${({ theme }) => theme.colors.CollaboBlue};
    }

    .claimed-text,
    .claimed-amount {
      margin: 0;
    }

    .claimed-amount {
      color: ${({ theme }) => theme.colors.successGreen};
    }
  }
`

export {
  GeneralEarnWrapper,
  EarnContainer,
  InviteFriendContent,
  ClaimRewardContent,
}

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};

  .title {
    color: ${({ theme }) => theme.colors.navyBlue};
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-size: ${({ theme }) => theme.fontSize.xl};
    margin-top: 38px;
  }

  .earn_text {
    margin: 20px 0;
  }
  .header-welcome {
    margin-top: -20px;
  }
`
export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 34px;
  div {
    width: 100%;
    .active {
      background: rgba(224, 224, 224, 0.4);
      border-radius: 5.3865px;
      outline: none;
      font-style: normal;
      font-weight: 400;
      font-size: 17.5061px;
      line-height: 21px;
      color: ${({ theme }) => theme.colors.CardDark};
    }
  }
`

export const InviteWrapper = styled.div`
  .container {
    display: none;
  }
  .active-container {
    display: block;
  }
  .image {
    width: 90%;
  }
  .first {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .image-first {
      height: 224px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .content {
      margin-top: -20px;
      p {
        padding: 0px 10px;
      }
    }
    .content-copy {
      margin: 20px 25px;
    }
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      text-align: center;
      letter-spacing: 0.25px;
      color: ${({ theme }) => theme.colors.Cmk};
    }
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      letter-spacing: -0.048px;
      color: ${({ theme }) => theme.colors.DarkCyan};
      margin-top: -10px;
    }
    .link {
      background: rgba(87, 102, 255, 0.1);
      border-radius: 6px;
      height: 28px;
      width: 100%;
      padding-left: 10px;
      span {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        color: ${({ theme }) => theme.colors.secondPrimary};
      }
    }
  }
`

export const RewardWrapper = styled.div`
  .container {
    display: none;
  }
  .active-container {
    display: block;
  }
  .withdraw {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: ${({ theme }) => theme.colors.CardDark};
  }
  .second {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${({ theme }) => theme.colors.secondPrimary};
    border-radius: 8px;
    width: 100%;
    margin-top: 40px;
    height: 111px;
    span {
      height: 81px;
      width: 5px;
      opacity: 0.1;
      background: white;
    }
    div {
      width: 50%;
      padding: 0px 25px;

      h2 {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: ${({ theme }) => theme.colors.white};
      }
      p {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: -0.3px;
        color: #f2f2f2;
        margin-top: -10px;
      }
    }
  }
`
export const CopyButton = styled.button`
  background: #6979f8;
  border-radius: 5px;
  height: 50px;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  width: 100%;
  /* width: 370px; */
  outline: none;
  border: 2px solid #6979f8;
  cursor: pointer;
`
